export interface QueryParser {
  getQueryParam(paramName: string): string | undefined;
}

export interface SimpleQueryLocation {
  (): string | undefined;
}

export class SimpleQueryParser implements QueryParser {
  private location: SimpleQueryLocation;

  constructor(queryLocation: SimpleQueryLocation | undefined = undefined) {
    if (queryLocation) {
      this.location = queryLocation;
    } else {
      this.location = (): string | undefined => {
        if (!window || !window.location || !window.location.search) {
          return undefined;
        }
        return window.location.search;
      };
    }
  }

  public getQueryParam = (paramName: string): string | undefined => {
    const location = this.location();
    if (!location) {
      return undefined;
    }

    const queryParams: string[] = location.substring(1).split('&');

    for (let i = 0; i < queryParams.length; i += 1) {
      const [key, value] = queryParams[i].split('=');

      if (key === paramName && value) {
        return decodeURIComponent(value);
      }
    }

    return undefined;
  };
}
